import styled from '@emotion/styled';

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({theme}) => theme.gap.desktop.xl};
`;

export const ProfileDetails = styled.div`
  display: grid;
  gap: ${({theme}) => theme.gap.desktop.lg};
  grid-template-columns: repeat(auto-fit, minmax(264px, 1fr));

  @media screen and (max-width: ${({theme}) => theme.screenBreakpoint.md.px}) {
    display: flex;
    flex-direction: column;
  }
`;

export const LinkContactWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
